import { createSlice } from "@reduxjs/toolkit"

let getThemeFromLocalStorage = localStorage.getItem("tis_weight_loss_theme") || "light";

const themeSlice = createSlice({
  name: "themeSlice",
  initialState: { theme: getThemeFromLocalStorage },
  reducers: {
    toggleTheme: (state, action) => {
      // true = dark
      // false = light
      if (action.payload.theme === true) {
        state.theme = "dark";
        localStorage.setItem("tis_weight_loss_theme", "dark")
      } else {
        state.theme = "light";
        localStorage.setItem("tis_weight_loss_theme", "light")
      }
    }
  }
})

export const { toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;
